import React, { memo } from 'react';
import { createPortal } from 'react-dom';

import { getDataGridTooltipId } from '../utils/getDataGridTooltipElement';

const Tooltip = memo(({ tableId }) => {
    return createPortal(
        <div id={getDataGridTooltipId(tableId)} className="w5-tooltip">
            <div className="w5-tooltip-content"></div>
            <div className="w5-tooltip-arrow" data-popper-arrow></div>
        </div>,
        document.body,
    );
});

export default Tooltip;
